import styled, { keyframes, css } from "styled-components";
import {
  textApearAnim,
  scaleOnClickAnim,
  OPfadeInAnim,
} from "../../animations";

const swiperApear = keyframes`
  0% {
    transform: translateY(56px);
  }
  46% {
    transform: translateY(4px);
    animation-timing-function: cubic-bezier(0.17, 0.17, 0.04, 0.92);
  }
  100% {
    transform: translateY(0px);
    animation-timing-function: cubic-bezier(0.29,0.36,0.62,1);
  }
`;

const subtextFadeOut = keyframes`
  0% {
    transform: translateX(50%) translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateX(50%)  translateY(-56px);
    opacity: 0;
    animation-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
  }
`;

const slideApear = keyframes`
  0% {
    transform: translateY(15px);
    opacity: 0;
  }
  16% {
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
    animation-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
  }
`;
const swiperApearAnim = css`
  ${swiperApear}
`;
const subtextFadeOutAnim = css`
  ${subtextFadeOut}
`;
const slideApearAnim = css`
  ${slideApear}
`;
export const SubTitle = styled.div`
  /* font-size: 16px; */
  color: #483b3b;
  text-transform: uppercase;
  text-align: center;
  /* margin-bottom: 16px; */
  height: 20px;
  font-size: 20px;
  margin-bottom: 36px;
  ${(props) => (props.win ? "color: #ffb000;" : "color: #483b3b;")}
  animation: ${(p) => (p.res ? textApearAnim : null)};
  animation-duration: 0.467s;
  animation-fill-mode: forwards;
  @media only screen and (min-width: 375px) {
    font-size: 20px;
    margin-bottom: 36px;
  }
`;
export const Wrapper = styled.div`
  /* transform: ${(p) => (p.pickA ? "translateX(-20px)" : null)};
  transition: transform 1s; */
  display: flex;
  right: 0;
  position: absolute;
  min-width: 100%;
  /* overflow:hidden; */
  justify-content: center;
  transition: all 0.517s;
`;
export const ArrowDiv = styled.div`
  height: 20px;
  width: 40px;
  display: flex;
  justify-items: center;
  align-items: center;
  animation: ${(p) =>
    p.arrowClicked ? scaleOnClickAnim : p.arrowInit ? OPfadeInAnim : null};
  animation-duration: ${(p) => (p.arrowInit ? "0.250s" : "0.333s")};
  animation-fill-mode: forwards;
  transition: all 0.517s;
  position: relative;
  cursor: pointer;
  div {
    position: absolute;
    width: 100%;
  }

  :last-child {
    display: flex;
    justify-items: center;
    align-items: center;
    animation: test;
    animation-duration: 0.517s;
    animation-fill-mode: forwards;

    div {
      opacity: 0;
      animation: ${slideApearAnim};
      animation-duration: 0.517s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    @keyframes test {
      0% {
        width: 0px;
      }
      100% {
        width: 40px;
      }
    }
  }
`;

export const Swiper = styled.div`
  /* font-size: 16px; */
  height: 20px;
  color: #483b3b;
  text-transform: uppercase;
  text-align: center;
  /* margin: 0 auto 16px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 285px;
  width: 100%;
  overflow: hidden;
  scrollbar-width: none;
  animation: ${swiperApearAnim};
  animation-duration: 0.25s;
  animation-fill-mode: forwards;
  font-size: 20px;
  margin: 0 auto 36px;
  @media only screen and (min-width: 375px) {
    font-size: 20px;
    margin: 0 auto 36px;
  }
`;
export const SubTitleInit = styled.div`
  color: #483b3b;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  word-break: nowrap;
  height: 20px;
  font-size: 20px;
  margin-bottom: 36px;
  ${(p) =>
    p.fadeOut
      ? "position: absolute;right: 50%;transform: translateX(50%); z-index: -1;"
      : null};
  ${(p) => (p.win ? "color: #ffb000;" : "color: #483b3b;")};
  animation: ${(p) =>
    p.init ? textApearAnim : p.fadeOut ? subtextFadeOutAnim : null};
  animation-duration: ${(p) => (p.fadeOut ? "0.250s" : " 0.467s")};
  animation-fill-mode: forwards;

  @media only screen and (min-width: 375px) {
    font-size: 20px;
    margin-bottom: 36px;
  }
`;
